import React from 'react'
import MuiTableContainer from '@mui/material/TableContainer'
import MuiTable from '@mui/material/Table'
import MuiTableBody from '@mui/material/TableBody'
import MuiTableHead from '@mui/material/TableHead'
import MuiTableRow from '@mui/material/TableRow'
import TableCell from 'components/dealwatch/TableCell'

const Table = ({ columnCount = 4, columnTitles = [], children: body, className }) => {
  while (columnTitles.length < columnCount) {
    columnTitles.push('')
  }

  return (
    <MuiTableContainer>
      <MuiTable {...{ className }}>
        <MuiTableHead classes={{ root: 'bg-white bb-medium bt-thick b--dark-sea-green-3 mt1' }}>
          <MuiTableRow>
            {columnTitles.map((title, index) => (
              <TableCell key={index} cxNames='b pv4'>{title}</TableCell>
            ))}
          </MuiTableRow>
        </MuiTableHead>
        <MuiTableBody>
          {body}
        </MuiTableBody>
      </MuiTable>
    </MuiTableContainer>
  )
}

export default Table
